/**
 * Image + Text section that alternates which side the image is on (used for Foreward, PAGE Strategy, Sustainable Development, etc.)
 */

import React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Modal from "./modal"
import { kebabCase } from "lodash"
import "../styles/alt-image-text.css"
import CopyLinkButton from "./copy-link-button"

const AltImageText = ({ props, annualReport }) => {
  const {
    heading,
    includeInStickyMenu,
    content,
    modalContent,
    buttonText,
    button,
    imageBackgroundColor,
    imageCrop,
    backgroundColorAr: backgroundColor
  } = props
  const image = {
    src: props.image?.localFile ? getImage(props.image?.localFile) : null,
    alt: props.image?.altText || ``,
    publicURL: props.image?.localFile?.publicURL,
    caption: props.image?.caption,
  }
  const isGreenRecovery = props.image?.localFile?.publicURL
    ?.toLowerCase()
    .includes("green-recovery")
  let maxWidthVal = "none"
  if (
    props.image?.localFile?.publicURL
      ?.toLowerCase()
      .includes("management-board-statement") ||
    props.image?.localFile?.publicURL?.toLowerCase().includes("-sdgs.")
  ) {
    maxWidthVal = "26rem"
  } else if (isGreenRecovery) {
    maxWidthVal = "16rem"
  }
  return (
    <altsection
      className={`section alt-image-text overflow-visible
      `}
      key={heading || includeInStickyMenu?.menuTitle}
    >
      <section className={`
      ${(!backgroundColor || backgroundColor === "white") ? "bg-white m-section" : `p-section`}
      ${annualReport === "2023" ? (`bg-cover ${backgroundColor === "blue" ? "bg-blue-blobs" : backgroundColor === "green" ? "bg-green-blobs" : backgroundColor === "gray" ? "bg-gray-blobs" : backgroundColor === "teal" ? "bg-teal-blobs" : ""}`)
          : (backgroundColor === "blue" ? "bg-blue-100" : backgroundColor === "green" ? "bg-green-100" : backgroundColor === "gray" ? "bg-gray-200" : backgroundColor === "teal" ? "bg-teal-50" : "")} 
            `}>
        <div className="relative container">
          <div
            className={`relative grid ${(image?.src || image?.publicURL) &&
              (heading || content || modalContent || button)
              ? "xl:grid-cols-2 xl:gap-12 xl:grid-flow-row-dense"
              : "mx-auto xl:w-2/3"
              } xl:items-center`}
          >
            {(heading || content || modalContent || button) && (
              <div
                className={`xl:col-span-1 xl:grid-flow-row-dense relative col-first ${annualReport === "2023" ? "bg-white/70 sm:p-6 relative" : ""}`}
              >
                {annualReport === "2023" ? <div className="absolute top-0 right-0 w-10 h-full "></div> : ""}
                <div className={`${annualReport === "2022" ? `border-l-6 pl-4 relative ${backgroundColor === "white" || backgroundColor === "blue" ? "border-l-blue" :
                  backgroundColor === "green" || backgroundColor === "gray" ? "border-l-green" :
                    backgroundColor === "teal" ? "border-l-teal" : "border-l-blue"}` : annualReport === "2023" ? "" : ""}`}>
                  {heading ? (
                    <div className={`group-copy-link group grid grid-cols-1 justify-start`}>
                      <h2
                        className={`anchor-heading ${isGreenRecovery ? "h3 pb-4" : "pb-4"}`}
                        id={kebabCase(heading).replace(/[0-9]/g, "")}
                      >
                        {heading}
                      </h2>
                      <CopyLinkButton heading={heading} />
                    </div>
                  ) : includeInStickyMenu?.menuTitle ? (
                    <div
                      id={
                        kebabCase(
                          includeInStickyMenu.menuTitle.replace(/[0-9]/g, "")
                        ) || ""
                      }
                    >
                      <CopyLinkButton heading={includeInStickyMenu.menuTitle} />
                    </div>
                  ) : null}

                  {content ? (
                    <div
                      className="parsed-content"
                    >
                      {parse(content)}
                    </div>
                  ) : null}
                </div>
                {modalContent?.length ? (
                  <Modal
                    modalContent={modalContent}
                    heading={heading}
                    buttonText={buttonText}
                  ></Modal>
                ) : button ? (
                  <p className="mt-8">
                    <Link
                      to={button.url}
                      target={button.target}
                      className={`btn ${backgroundColor === "white" || backgroundColor === "blue" ? "btn-blue" :
                        backgroundColor === "green" || backgroundColor === "gray" ? "btn-green" :
                          backgroundColor === "teal" ? "btn-teal" : "btn-blue"}`}
                    >
                      {button.title ? parse(button.title) : null}
                    </Link>
                  </p>
                ) : null}
              </div>
            )}

            {image?.src || image?.publicURL ? (
              <figure
                className={`xl:col-span-1 xl:grid-flow-row-dense mt-10 h-auto ${imageCrop ? "aspect-[4/3] max-h-[50vh]" : ""} xl:mt-0 col-second relative`}
              >
                {image?.src ? (
                  imageCrop ? (
                    <div
                      className="img-container absolute inset-0"
                    >
                      <ImageBackground imageBackgroundColor={imageBackgroundColor} annualReport={annualReport} />

                      <GatsbyImage
                        image={image.src}
                        className="w-full h-full"
                        objectPosition={props.imagePosition || "center"}
                        objectFit="cover"
                        alt={image.alt}
                      />

                      {/* <svg
                        className="img-overlay hidden absolute inset-y-0 h-full w-28 text-white transform"
                        fill="currentColor"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                      >
                        <polygon points="50,0 100,0 70,100 00,100" />
                      </svg> */}
                    </div>
                  ) : (
                    <div
                      className="h-full flex items-center justify-center mx-auto"
                      style={{ maxWidth: maxWidthVal }}
                    >
                      <div className="relative">
                        <GatsbyImage
                          image={image.src}
                          className="mx-auto my-auto xl:min-h-[24rem] max-h-[50vh]"
                          style={{ maxWidth: maxWidthVal }}
                          imgStyle={{ maxWidth: maxWidthVal }}
                          objectFit="contain"
                          alt={image.alt}
                        />
                      </div>
                    </div>
                  )
                ) : image?.publicURL ? (
                  <img
                    src={image.publicURL}
                    className={`${isGreenRecovery ? "ml-auto" : "mx-auto my-auto"
                      }`}
                    alt={image.alt}
                    style={{ maxWidth: maxWidthVal }}
                  />
                ) : null}
                {image?.caption ? (
                  <figcaption className="text-sm text-gray-600 mt-2" dangerouslySetInnerHTML={{ __html: image.caption }}></figcaption>
                ) : null}
              </figure>
            ) : null}
          </div>
        </div>
      </section>
    </altsection>
  )
}

function ImageBackground({ imageBackgroundColor, annualReport }) {
  return (
    <div
    aria-hidden
    className={`img-bg ${imageBackgroundColor ? `` : "bg-transparent"
      }`}
    style={{
      backgroundImage:
        annualReport === "2023" ? `linear-gradient(to bottom left, ${imageBackgroundColor}, rgba(255,255,255,0))` :
          `linear-gradient(to bottom, ${imageBackgroundColor}, rgba(255,255,255,0))`,
    }}
  />
  )
}

export default AltImageText
